(() => {
  if (customElements.get('heliconia-black-weekend')) return;
  class BlackWeekend extends HTMLElement {
    connectedCallback() {
      this.startsAt = Number(this.dataset.startsAt) * 1000;
      this.endsAt = Number(this.dataset.endsAt) * 1000;
      this.refresh = this.update.bind(this);
      document.addEventListener('visibilitychange', this.refresh);
      window.addEventListener('pageshow', this.refresh);
      this.update();
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      document.removeEventListener('visibilitychange', this.refresh);
      window.removeEventListener('pageshow', this.refresh);
    }
    update() {
      clearTimeout(this.timer);
      let now = Date.now();
      // A draft preview can show all three phases without changing the sale.
      if (window.Shopify?.theme?.role && window.Shopify.theme.role !== 'main') {
        const preview = new URLSearchParams(window.location.search).get('bw_preview');
        if (preview === 'active') now = this.startsAt + 1000;
        if (preview === 'expired') now = this.endsAt;
      }
      const visible = Number.isFinite(this.endsAt) && now < this.endsAt;
      this.hidden = !visible;
      if (this.hasAttribute('data-store-banner')) {
        document.documentElement.toggleAttribute('data-black-weekend-visible', visible);
      }
      if (!visible) return;
      const phase = now < this.startsAt ? 'upcoming' : 'active';
      this.dataset.phase = phase;
      this.querySelectorAll('[data-phase-text]').forEach(node => {
        node.hidden = node.dataset.phaseText !== phase;
      });
      const boundary = phase === 'upcoming' ? this.startsAt : this.endsAt;
      this.timer = setTimeout(this.refresh, Math.min(boundary - now + 100, 2147483647));
    }
  }
  customElements.define('heliconia-black-weekend', BlackWeekend);
})();
